import { useFormik } from 'formik';
import React, { useEffect, useContext } from 'react';
import { Button, Form, Modal, Col, Alert } from 'react-bootstrap';
import { useImmer } from 'use-immer';
import * as Yup from "yup";
import FormControls, { ConditionalRender } from '../formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { MessageService, UserService } from '../../services';
import { AuthContext } from '../../contexts/AuthContext';
import { useState } from 'react';
import _ from 'lodash';

const limitStringLen = (str, maxLength = 20) => {
    //const re = /(?:\.([^.]+))?$/;
    const split = str.split('.');
    const ext = split.pop();
    let tmpStr = split.join();
    if (tmpStr.length > maxLength) {

        tmpStr = tmpStr.slice(0, (maxLength / 2)) + '...' + tmpStr.slice(tmpStr.length - (maxLength / 2) + 1);
        return tmpStr + '.' + ext;
    }
    return str;
}

const initValues = {
    "sentFromUserId": null,
    "accountId": null,
    "sentToUserId": null,
    "codingEventId": null,
    "subject": '',
    "message": '',
    "attachments": [],
    "audience": []
}

const messageValidationSchema = {
    subject: Yup.string().required('Subject is required.')
        .min(2, 'Subject must contain more than one characters.')
        .max(500, 'Subject must have less than 500 characters.'),
    message: Yup.string().required('Message is required.')
        .min(2, 'Message must contain more than one characters.')
        .max(4000, 'Message must have less than 4000 characters.'),
    sentToUserId: Yup.number().required('You must select a recipient.')
        .min(2, 'You must select a recipient.').nullable(),
    accountId: Yup.number().required('Account is required.').min(1, 'Account is required.').nullable()
};

const CreateMessageModal = (props) => {
    const [newMessage, setNewMessage] = useImmer({});
    const [contacts, setContacts] = useImmer([]);
    const [showAccounts, setShowAccounts] = useState();
    const [currentUserId, setCurrentUserId] = useImmer();
    const [currentAccountId, setCurrentAccountId] = useImmer();
    const [allContacts, setAllContacts] = useImmer([]);
    const [accounts, setAccounts] = useImmer([])
    const [serviceCallError, setServiceCallError] = useImmer(null);


    const authContext = useContext(AuthContext);

    const formHandler = useFormik({
        initialValues: newMessage,
        validationSchema: Yup.object().shape(messageValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            await saveMessage(values);
            setSubmitting(false);
        }
    });

    useEffect(() => {
        const userId = authContext.currentUser.id;
        const accountId = props.model.codingEventId ? props.model.accountId : parseInt(authContext.getClaim(authContext.claims.accountId));
        setCurrentUserId(userId);
        setCurrentAccountId(accountId);
    }, [])

    //useEffect(() => {
    //}, [])

    useEffect(() => {
        if (props.model != undefined) {
            // set initial values to newMessage
            let initMessage = _.clone(initValues);
            Object.assign(initMessage, props.model);
            if (props.model.codingEventId) {
                setCurrentAccountId(props.model.accountId);
            }
            setNewMessage(initMessage)
            getContacts();
        }
    }, [props.model])

    const getContacts = async () => {
        var userService = new UserService();
        let params = {}
        if (props.model.codingEventId) {
            params = { "accountIdFilter": props.model.accountId, "codingEventId": props.model.codingEventId };
        }
        var callResult = await userService.getContactsForUser(params);
        if (callResult.result) {
            const localAllContacts = callResult.model.accounts;
            let otherAccounts = localAllContacts.filter(acc => acc.accountId != formHandler.values.accountId &&
                                                               acc.accountId != props.model.accountId &&
                                                               acc.accountId != 1);
            if (otherAccounts.length > 0 && !props.model.codingEventId) {
                formHandler.setFieldValue("accountId", null, true);
                setShowAccounts(true);
            } else {
                setShowAccounts(false);
            }
            //let availAccounts = localAllContacts.filter(acc => acc.id == formHandler.values.accountId || acc.id == 1);
            let availAccounts = localAllContacts.map(acc => ({ name: acc.name, label: acc.name, id: acc.accountId, value: acc.accountId }));
            setAccounts(availAccounts);
            setAllContacts(localAllContacts);
        } else {
            setServiceCallError({title: "Error fetching contacts.", text: callResult.message})
        }
    }

    useEffect(() => {
        updateContactList();
    }, [allContacts, formHandler.values.accountId])

    const updateContactList = () => {
        // remove senttoid or audience where accountid isn't 1 or selected
        if (formHandler.values.sentToUserId != 1 && formHandler.values.sentToUserId != formHandler.values.accountId || formHandler.values.sentToUserId != currentAccountId) {
            formHandler.setFieldValue("sentToUserId", null, true)
        }

        var newAudience = formHandler.values.audience?.filter(contact => contact.accountId == 1 || contact.accountId == formHandler.values.accountId || contact.accountId == currentAccountId);

        formHandler.setFieldValue("audience", newAudience, false)

        const filteredContacts = allContacts.filter(account => account.accountId == 1 || account.accountId == formHandler.values.accountId || account.accountId == currentAccountId);
        let contacts = [];
        if (filteredContacts?.length > 0)
            contacts = filteredContacts.map(grp => ({
                        label: grp.name, id: grp.id, options: grp.contacts.map(cntc => ({
                            label: cntc.fullName + ' (' + cntc.accountName + ')', value: cntc.id, accountId: grp.id, userId: cntc.id, accountName: grp.name
                        }))
        }))
        setContacts(contacts);

         //[
        //    {
        //        label: 'Group', options: [
        //            { label: 'Option 1', value: '1' },
        //            { label: 'Option 2', value: '2' }
        //        ]
        //    }
        //] 
    }

    const  saveMessage = async (values) => {
        const service = new MessageService();
        const callResult = await service.createMessage(values);
        if (callResult.result) {
            const model = callResult.model;
            let attachmentError = false;
            if (formHandler.values.attachments?.length > 0) {
                var attachResult = await attachFiles(values.attachments, model.id);
                attachmentError = !attachResult;
            }
            if (!attachmentError) {
                props.onSaveCallback();
                props.closeModal();
            }
        } else {
            setServiceCallError({ title: "Error saving message.", text: callResult.message })
        }
    }

    const attachFiles = async (files, messageId) => {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i], files[i].name); //{ "file": files[i], "fileName": files[i].name }
        }

        formData.append(
            "messageId", messageId
        );

        //if (selectedFile.name !== 'Select file') {
        //    formData.append(
        //        "file",
        //        selectedFile,
        //        selectedFile.name
        //    );

        //    formData.append(
        //        "codingEventId", props.codingEventId
        //    );
        //    formData.append(
        //        "name", name != '' ? name : selectedFile.name
        //    );
        const service = new MessageService();
        const callResult = await service.attachFiles(formData, messageId);
        if (callResult.result) {
            return true; // success
        } else {
            setServiceCallError({ title: "Error attaching files.", text: callResult.message })
            return false; // failed
        }
    }

    return (
        <>
            <Modal.Header>Create New Message</Modal.Header>
            <Modal.Body>
                {/*{JSON.stringify(formHandler.values, null, 2)}<br />*/}
                {/*{JSON.stringify(formHandler.errors, null, 2)}<br />*/}
                {/*{JSON.stringify(formHandler.touched, null, 2)}*/}
                <ConditionalRender visible={serviceCallError}>
                    <Alert variant="danger">
                        <Alert.Heading>{serviceCallError?.title}</Alert.Heading>
                        {serviceCallError?.text}
                    </Alert>
                </ConditionalRender>
                <ConditionalRender visible={showAccounts}>
                    <Form.Row>
                        <Form.Group as={Col} lg="12" md="12">
                            <FormControls.SearchSelect
                                options={accounts}
                                placeholder="Select an account..."
                                name="accountId"
                                label="Selected Account"
                                formHandler={formHandler}
                            />
                        </Form.Group>
                    </Form.Row>
                </ConditionalRender>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.SearchSelect
                            options={contacts}
                            placeholder="Select a recipient..."
                            name="sentToUserId"
                            label="Recipient"
                            formHandler={formHandler}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Multiselect
                            options={contacts}
                            placeholder="Select one or many participants..."
                            name="audience"
                            label="Add Participants"
                            handleChange={formHandler.handleChange}
                            formHandler={formHandler}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Textbox
                            label="Subject"
                            name="subject"
                            formHandler={formHandler}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Textarea
                            label="Message"
                            name="message"
                            formHandler={formHandler}
                            rows="6" />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.FileSelector
                            name="attachments"
                            label="Attachments"
                            formHandler={formHandler} />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.closeModal}>Cancel</Button>
                <Button variant="primary" disabled={formHandler.isSubmitting} onClick={() => formHandler.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
};

export default CreateMessageModal;